export const RESET_CURRENT_USER = 'RESET_CURRENT_USER'
export const BOOTSTRAP_CURRENT_USER = 'BOOTSTRAP_CURRENT_USER'
export const BOOTSTRAP_ACCOUNT_TYPES = 'BOOTSTRAP_ACCOUNT_TYPES'
export const BOOTSTRAP_DEFAULT_ACCOUNT ='BOOTSTRAP_DEFAULT_ACCOUNT'
export const UPDATE_CURRENT_USER = 'UPDATE_CURRENT_USER'
export const ACHOR_USERS = 'ACHOR_USERS'
export const BOOTSTRAP_DEFAULT_ROLE = 'BOOTSTRAP_DEFAULT_ROLE'
export const BOOTSTRAP_DEFAULT_STATUS = 'BOOTSTRAP_DEFAULT_STATUS'
export const BOOTSTRAP_DEFAULT_COUNTRY = 'BOOTSTRAP_DEFAULT_COUNTRY'

export const BOOTSTRAP_ROLE_TYPES = 'BOOTSTRAP_ROLE_TYPES'
export const BOOTSTRAP_STATUS_TYPES = 'BOOTSTRAP_STATUS_TYPES'
